






























































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';

@Component({
	name: 'InformationAboutClaimIncidentFields',
	components: {
		SelectField,
		TextField,
		RadioField,
	},
})
export default class InformationAboutClaimIncident extends Vue {
	@State('policies', { namespace: 'Policy' }) private policies: any;

	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	private readonly reportTypes: readonly string[] = Object.freeze([
		'Lawsuit',
		'Pre-Suit or Medical Liability Screening Panel',
		'Licensing Board issue',
		'Claim',
		'Cyber or HIPAA Claim',
		'HEAL Consultation',
		'Deposition or Meeting Request',
		'Patient Medical Expense',
		'Request for Medical Record',
		'Notice Only – Potential Claim (PCE)',
		'Others',
	]);
	private readonly statesList = statesList;

	get sameAsAddresses() {
		const contactList = [];
		if (
			this.values.insuredsPolicyInformation.reportingForAAN === 'Both' ||
			this.values.insuredsPolicyInformation.reportingForAAN === 'Group'
		) {
			if (
				this.values.involvedInsuredsHealthCareProviders.group.groupName !== '' &&
				!this.values.involvedInsuredsHealthCareProviders.group.sameContactAs
			) {
				contactList.push({
					id: 'group',
					name:
						'Entity - ' +
						this.values.involvedInsuredsHealthCareProviders.group.groupName,
				});
			} else if (this.values.involvedInsuredsHealthCareProviders.group.sameContactAs) {
				contactList.push(
					this.values.involvedInsuredsHealthCareProviders.group.sameContactAs,
				);
			}
		}

		if (
			this.values.insuredsPolicyInformation.reportingForAAN === 'Both' ||
			this.values.insuredsPolicyInformation.reportingForAAN === 'Individual'
		) {
			this.values.involvedInsuredsHealthCareProviders.providers.forEach((provider, index) => {
				if (provider.firstName !== '' && !provider.sameContactAs) {
					contactList.push({
						id: 'provider' + index,
						name:
							'Provider ' +
							(index + 1) +
							' - ' +
							provider.firstName +
							' ' +
							provider.lastName +
							' | ' +
							provider.streetAddress,
					});
				} else if (provider.sameContactAs) {
					contactList.push(provider.sameContactAs);
				}
			});
		}

		return contactList;
	}
}
